import angular from 'angular';
import pendientesItemsComponent from './pendientes-items.component';
import pendientesItemsService from './pendientes-items.service';
import pendientesItemsConfig from './pendientes-items.config';

let pendientesItemsModule = angular.module('app.reports.pendientes-items',[])
  .component('reportPendientesItems', pendientesItemsComponent)
  .service('ReportPendientesItemsService', pendientesItemsService)
  .config(pendientesItemsConfig);

export default pendientesItemsModule; 



/** WEBPACK FOOTER **
 ** ./www/components/reports/pendientesItems/pendientes-items.js
 **/